import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/qq': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M433.8 420.4C422.2 421.8 388.9 367.7 388.9 367.7 388.9 399 372.8 440 337.8 469.5 354.7 474.7 392.7 488.7 383.6 503.9 376.3 516.3 258.1 511.8 224 507.9 189.9 511.8 71.7 516.3 64.4 503.9 55.3 488.7 93.3 474.7 110.2 469.5 75.2 440 59.1 399.1 59.1 367.7 59.1 367.7 25.8 421.8 14.2 420.4 8.9 419.8 1.8 390.8 23.6 320.7 33.9 287.7 45.6 260.3 63.7 215 60.7 98.1 109 0 224 0 337.7 0 387.2 96.1 384.3 215 402.4 260.2 414.2 287.8 424.4 320.7 446.2 390.8 439.1 419.8 433.8 420.4z'
      }
    ]
  }
})
